import { Alert, AlertTitle } from '@frontend-workspace/react-shared-lib';
import styles from './denied-access-page.module.scss';

/* eslint-disable-next-line */
export interface DeniedAccessPageProps { }

export function DeniedAccessPage(props: DeniedAccessPageProps) {
  return (
    <div className={`${styles.center}`}>
      <Alert severity="info">
        <AlertTitle>
          Adgang mangler
        </AlertTitle>
        Vi beklager, men du har ikke rettigheter til å se denne siden. <br />
        Vennligst ta kontakt med system-administrator.
      </Alert>
    </div>
  );
}

export default DeniedAccessPage;